/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  NarrativeClassifierType,
  NarrativeCreate,
  NarrativeResponse,
  NarrativeType,
  NarrativeUpdate,
  VideoNarrativesClassificationsRequest,
  VideoNarrativesClassificationsResponse,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    NarrativeClassifierTypeFromJSON,
    NarrativeClassifierTypeToJSON,
    NarrativeCreateFromJSON,
    NarrativeCreateToJSON,
    NarrativeResponseFromJSON,
    NarrativeResponseToJSON,
    NarrativeTypeFromJSON,
    NarrativeTypeToJSON,
    NarrativeUpdateFromJSON,
    NarrativeUpdateToJSON,
    VideoNarrativesClassificationsRequestFromJSON,
    VideoNarrativesClassificationsRequestToJSON,
    VideoNarrativesClassificationsResponseFromJSON,
    VideoNarrativesClassificationsResponseToJSON,
} from '../models/index';

export interface ClassifyVideoNarrativesApiNarrativesClassficationsPostRequest {
    videoNarrativesClassificationsRequest: VideoNarrativesClassificationsRequest;
    xApiKey?: string | null;
}

export interface CreateNarrativeApiNarrativesPostRequest {
    narrativeCreate: NarrativeCreate;
    xApiKey?: string | null;
}

export interface DeleteNarrativeApiNarrativesNarrativeIdDeleteRequest {
    narrativeId: number;
    xApiKey?: string | null;
}

export interface GetNarrativeApiNarrativesNarrativeIdGetRequest {
    narrativeId: number;
    xApiKey?: string | null;
}

export interface GetNarrativeMappingsApiNarrativesMappingsGetRequest {
    xApiKey?: string | null;
}

export interface GetNarrativeTypesApiNarrativesTypesGetRequest {
    xApiKey?: string | null;
}

export interface ListNarrativesApiNarrativesGetRequest {
    classifierType?: NarrativeClassifierType | null;
    xApiKey?: string | null;
}

export interface UpdateNarrativeApiNarrativesNarrativeIdPatchRequest {
    narrativeId: number;
    narrativeUpdate: NarrativeUpdate;
    xApiKey?: string | null;
}

/**
 * 
 */
export class NarrativesApi extends runtime.BaseAPI {

    /**
     * Get the classifications of a video by multiple narratives.
     * Classify Video Narratives
     */
    async classifyVideoNarrativesApiNarrativesClassficationsPostRaw(requestParameters: ClassifyVideoNarrativesApiNarrativesClassficationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VideoNarrativesClassificationsResponse>> {
        if (requestParameters['videoNarrativesClassificationsRequest'] == null) {
            throw new runtime.RequiredError(
                'videoNarrativesClassificationsRequest',
                'Required parameter "videoNarrativesClassificationsRequest" was null or undefined when calling classifyVideoNarrativesApiNarrativesClassficationsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/narratives/classfications`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VideoNarrativesClassificationsRequestToJSON(requestParameters['videoNarrativesClassificationsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VideoNarrativesClassificationsResponseFromJSON(jsonValue));
    }

    /**
     * Get the classifications of a video by multiple narratives.
     * Classify Video Narratives
     */
    async classifyVideoNarrativesApiNarrativesClassficationsPost(requestParameters: ClassifyVideoNarrativesApiNarrativesClassficationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VideoNarrativesClassificationsResponse> {
        const response = await this.classifyVideoNarrativesApiNarrativesClassficationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new narrative.  The narrative_id will be auto-generated.
     * Create Narrative
     */
    async createNarrativeApiNarrativesPostRaw(requestParameters: CreateNarrativeApiNarrativesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NarrativeResponse>> {
        if (requestParameters['narrativeCreate'] == null) {
            throw new runtime.RequiredError(
                'narrativeCreate',
                'Required parameter "narrativeCreate" was null or undefined when calling createNarrativeApiNarrativesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/narratives`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NarrativeCreateToJSON(requestParameters['narrativeCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NarrativeResponseFromJSON(jsonValue));
    }

    /**
     * Create a new narrative.  The narrative_id will be auto-generated.
     * Create Narrative
     */
    async createNarrativeApiNarrativesPost(requestParameters: CreateNarrativeApiNarrativesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NarrativeResponse> {
        const response = await this.createNarrativeApiNarrativesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a narrative by ID.  This will also cascade delete all associated narrative_mappings_results.
     * Delete Narrative
     */
    async deleteNarrativeApiNarrativesNarrativeIdDeleteRaw(requestParameters: DeleteNarrativeApiNarrativesNarrativeIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['narrativeId'] == null) {
            throw new runtime.RequiredError(
                'narrativeId',
                'Required parameter "narrativeId" was null or undefined when calling deleteNarrativeApiNarrativesNarrativeIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/narratives/{narrative_id}`;
        urlPath = urlPath.replace(`{${"narrative_id"}}`, encodeURIComponent(String(requestParameters['narrativeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a narrative by ID.  This will also cascade delete all associated narrative_mappings_results.
     * Delete Narrative
     */
    async deleteNarrativeApiNarrativesNarrativeIdDelete(requestParameters: DeleteNarrativeApiNarrativesNarrativeIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteNarrativeApiNarrativesNarrativeIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get a specific narrative by ID
     * Get Narrative
     */
    async getNarrativeApiNarrativesNarrativeIdGetRaw(requestParameters: GetNarrativeApiNarrativesNarrativeIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NarrativeResponse>> {
        if (requestParameters['narrativeId'] == null) {
            throw new runtime.RequiredError(
                'narrativeId',
                'Required parameter "narrativeId" was null or undefined when calling getNarrativeApiNarrativesNarrativeIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/narratives/{narrative_id}`;
        urlPath = urlPath.replace(`{${"narrative_id"}}`, encodeURIComponent(String(requestParameters['narrativeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NarrativeResponseFromJSON(jsonValue));
    }

    /**
     * Get a specific narrative by ID
     * Get Narrative
     */
    async getNarrativeApiNarrativesNarrativeIdGet(requestParameters: GetNarrativeApiNarrativesNarrativeIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NarrativeResponse> {
        const response = await this.getNarrativeApiNarrativesNarrativeIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all available narrative mappings as id:name mapping.  This endpoint dynamically loads from the database, replacing the hardcoded list.
     * Get Narrative Mappings
     */
    async getNarrativeMappingsApiNarrativesMappingsGetRaw(requestParameters: GetNarrativeMappingsApiNarrativesMappingsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string | null; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/narratives/mappings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all available narrative mappings as id:name mapping.  This endpoint dynamically loads from the database, replacing the hardcoded list.
     * Get Narrative Mappings
     */
    async getNarrativeMappingsApiNarrativesMappingsGet(requestParameters: GetNarrativeMappingsApiNarrativesMappingsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string | null; }> {
        const response = await this.getNarrativeMappingsApiNarrativesMappingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all available narrative types.
     * Get Narrative Types
     */
    async getNarrativeTypesApiNarrativesTypesGetRaw(requestParameters: GetNarrativeTypesApiNarrativesTypesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NarrativeType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/narratives/types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NarrativeTypeFromJSON));
    }

    /**
     * Get all available narrative types.
     * Get Narrative Types
     */
    async getNarrativeTypesApiNarrativesTypesGet(requestParameters: GetNarrativeTypesApiNarrativesTypesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NarrativeType>> {
        const response = await this.getNarrativeTypesApiNarrativesTypesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all narratives with optional filtering.  - **narrative_type**: Filter by narrative type (related, sentiment, stance)
     * List Narratives
     */
    async listNarrativesApiNarrativesGetRaw(requestParameters: ListNarrativesApiNarrativesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NarrativeResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['classifierType'] != null) {
            queryParameters['classifier_type'] = requestParameters['classifierType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/narratives`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NarrativeResponseFromJSON));
    }

    /**
     * List all narratives with optional filtering.  - **narrative_type**: Filter by narrative type (related, sentiment, stance)
     * List Narratives
     */
    async listNarrativesApiNarrativesGet(requestParameters: ListNarrativesApiNarrativesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NarrativeResponse>> {
        const response = await this.listNarrativesApiNarrativesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing narrative.  Only provided fields will be updated.
     * Update Narrative
     */
    async updateNarrativeApiNarrativesNarrativeIdPatchRaw(requestParameters: UpdateNarrativeApiNarrativesNarrativeIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NarrativeResponse>> {
        if (requestParameters['narrativeId'] == null) {
            throw new runtime.RequiredError(
                'narrativeId',
                'Required parameter "narrativeId" was null or undefined when calling updateNarrativeApiNarrativesNarrativeIdPatch().'
            );
        }

        if (requestParameters['narrativeUpdate'] == null) {
            throw new runtime.RequiredError(
                'narrativeUpdate',
                'Required parameter "narrativeUpdate" was null or undefined when calling updateNarrativeApiNarrativesNarrativeIdPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/narratives/{narrative_id}`;
        urlPath = urlPath.replace(`{${"narrative_id"}}`, encodeURIComponent(String(requestParameters['narrativeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: NarrativeUpdateToJSON(requestParameters['narrativeUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NarrativeResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing narrative.  Only provided fields will be updated.
     * Update Narrative
     */
    async updateNarrativeApiNarrativesNarrativeIdPatch(requestParameters: UpdateNarrativeApiNarrativesNarrativeIdPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NarrativeResponse> {
        const response = await this.updateNarrativeApiNarrativesNarrativeIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
